import React from 'react';
import { IconButton } from '@mui/material';
import { Download } from '@mui/icons-material';

const DownloadImage = ({ imageUrl, imageName }) => {
  const downloadImage = async () => {
    try {
      const response = await fetch(imageUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = imageName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url); // Clean up the URL object
    } catch (error) {
      console.error('Error downloading the image:', error);
    }
  };

  return (
    <div>
      <IconButton onClick={downloadImage} size="small">
        <Download fontSize='small'/>
      </IconButton>
    </div>
  );
};

export default DownloadImage;
